/**
 * Error Handler
 * This function sends information to the server when an error is generated.
 */
import pricingStore from './store/pricingStore';
import userStore from './store/userStore';
import summaryStore from './store/internalSummary';

export default function errorHandler(error) {
  const errorBody = {
    appVersion: 1,
    errorType: `${error}`,
    errorCode: 0,
    user: userStore.user.email,
    currentUrl: window.location.href,
    storeContents: `${JSON.stringify(pricingStore)} ${JSON.stringify(userStore)} ${JSON.stringify(summaryStore)}`,
  };

  const errorMsg = `
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-content">
        <article class="message is-danger">
          <div class="message-header">
            <p>The application has encountered an error</p>
            <button class="delete js-delete" aria-label="delete"></button>
          </div>
          <div class="message-body">
            <p>You can close this message and try again. If this message appears again please
            refresh the page.</p>
          </div>
        </article>
      </div>
    </div>
  `;

  document.body.innerHTML += errorMsg;
  const modalContainer = document.querySelector('.modal');
  const removeBtn = document.querySelector('.js-delete');

  fetch('/api/error', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(errorBody),
  }).then(res => res.json())
    .then(() => {
      modalContainer.classList.add('is-active');
    });

  removeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    modalContainer.remove();
  });
}
